import { useTime } from '@/hooks/useTime';

export function Banner() {
    const time = useTime('America/Bogota').toLowerCase();

    return (
        <div className="text-neutral py-3 w-full px-4 md:px-0 max-w-7xl mx-auto flex justify-between items-center flex-wrap gap-4 border-neutral border-b">
            <div className="hidden sm:flex items-center gap-2 ">
                <span className="text-xs">Bogotá, CO {time}</span>
            </div>
            <div className="flex items-center justify-center gap-x-4 gap-y-2 flex-wrap">
                <div className="flex items-center">
                    <a href="https://github.com/Hazdan" target="_blank" className="text-xs">GitHub</a>
                </div>
                <div className="flex items-center">
                    <a href="https://linkedin.com/in/Hazdan" target="_blank" className="text-xs">LinkedIn</a>
                </div>
                <div className="flex items-center">
                    <a href="mailto:me.manuelromero@gmail.com" className="text-xs break-all">me.manuelromero@gmail.com</a>
                </div>
            </div>

        </div>
    );
}

export default Banner;
